/**
 * 내 학원 — 학부모 입장: 가입한 학원 (라인 리스트, 가입일·수강 자녀 표시)
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { useAcademy } from '../../context/AcademyContext';
import BrandLoader from '../../components/common/BrandLoader';

const FIELD_NAME = { study: '교과 과정', sports: '운동 / 태권도', arts: '음악 / 미술' };

const fmtDate = (iso) => {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const p = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}.${p(d.getMonth() + 1)}.${p(d.getDate())}`;
};

const MyAcademiesPage = () => {
  const navigate = useNavigate();
  const { joinedAcademies, loading } = useAcademy();

  if (loading) return <BrandLoader />;

  return (
    <Container>
      {joinedAcademies.length === 0 ? (
        <EmptyCard type="button" onClick={() => navigate('/app/home')}>
          + 학원 찾아 가입하기
        </EmptyCard>
      ) : (
        <List>
          {joinedAcademies.map((a) => (
            <Row
              key={a.id}
              type="button"
              onClick={() => navigate(`/app/member/${a.id}`)}
            >
              <Photo $url={a.photoUrl}>
                <StatusPill>수강 중</StatusPill>
              </Photo>
              <Info>
                <TagRow>
                  <CatTag>
                    {FIELD_NAME[a.field] || a.field}
                    {a.subject ? ` · ${a.subject}` : ''}
                  </CatTag>
                </TagRow>
                <Name>{a.name}</Name>
                {a.myChildren?.length > 0 && (
                  <Children>자녀 · {a.myChildren.map((c) => c.name).join(', ')}</Children>
                )}
                {a.myJoinedAt && <Meta>가입일 {fmtDate(a.myJoinedAt)}</Meta>}
              </Info>
            </Row>
          ))}
        </List>
      )}
    </Container>
  );
};

export default MyAcademiesPage;

const Container = styled.div`
  max-width: 480px;
  margin: 0 auto;
  padding: 8px 16px 24px;
`;

const List = styled.div`
  display: flex;
  flex-direction: column;
`;

const Row = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px 2px;
  background: none;
  text-align: left;
  border-bottom: 1px solid #F0F1F4;
  &:last-child { border-bottom: none; }
`;

const Photo = styled.div`
  position: relative;
  width: 104px;
  height: 104px;
  flex-shrink: 0;
  border-radius: 14px;
  background: ${({ $url }) => ($url ? `#EDEFF3 url(${$url}) center/cover` : '#EDEFF3')};
`;

const Info = styled.div`
  flex: 1;
  min-width: 0;
`;

const TagRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 6px;
  margin-bottom: 7px;
`;

const CatTag = styled.span`
  flex: 0 1 auto;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 12px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.text.secondary};
  background: #F2F3F7;
  padding: 4px 9px;
  border-radius: 7px;
`;

const StatusPill = styled.span`
  position: absolute;
  top: 7px;
  left: 7px;
  white-space: nowrap;
  font-size: 11.5px;
  font-weight: 700;
  color: #2E7D32;
  background: rgba(255, 255, 255, 0.92);
  padding: 4px 9px;
  border-radius: 8px;
`;

const Name = styled.p`
  font-size: 17px;
  font-weight: 800;
  color: ${({ theme }) => theme.colors.text.primary};
`;

const Meta = styled.p`
  font-size: 12.5px;
  color: ${({ theme }) => theme.colors.text.hint};
  margin-top: 6px;
`;

const Children = styled.p`
  font-size: 13.5px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.primary};
  margin-top: 6px;
`;

const EmptyCard = styled.button`
  width: 100%;
  padding: 18px;
  margin-top: 14px;
  border: 1px dashed ${({ theme }) => theme.colors.border};
  border-radius: 12px;
  background: #fff;
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.primary};
`;
